import React from 'react'
import Dotlottie from './Dotlottie'
import AppImage from '../../features/image'

function BBYLogo() {
    return (
        <>
            <AppImage src={'/images/common/logo-header.png'} alt='BBY Logo' title='BBY Logo' />
        </>
    )
}
BBYLogo.GIFAnimation = () => {
    return (
        <>
            <AppImage src={'/images/common/BBY-Ads-Logo-Web-122024.gif'} alt='BBY Logo' title='BBY Logo' />
        </>
    )
}
BBYLogo.Dotlottie = () => {
    return (
        <>
            <Dotlottie />
        </>
    )
}

export default BBYLogo